<template>
	<div class="page-in">
	<van-nav-bar
	  :title="$t('购物记录')"
	  fixed
	  placeholder
	  left-arrow
	  z-index="99"
	  @click-left="back"
	  :border="false"
	  v-if="isMobileFlag"
	/>
	<div class="inside-page">
		<div class="page-m-tabs" v-if="isMobileFlag">
			<div class="m-container" >
				<van-tabs v-model="activeName"  swipe-threshold="3" color="#8B6E35" >
				  <van-tab :title="$t('全部')">
					  <div class="h-lists">
					  	<div class="history-card" v-for="(item,index) in tableData" :key="index">
					  		<div class="h-photo"><img :src="item.pic" alt="" /></div>
					  		<div class="flex-col">
					  			<div class="h-title ellipsis">{{item.title}}</div>
					  			<div class="h-item">{{item.goodsinfo}}</div>
					  			<div class="h-item flex">
					  				<span class="text-primary">{{item.price}}</span>
					  				<span>{{item.status}}</span>
					  			</div>
					  		</div>
					  	</div>
					  </div>
				  </van-tab>
				  <van-tab :title="$t('全部')" title="已付款Thanh toán"></van-tab>
				  <van-tab :title="$t('全部')" title="运输中Giao thông vận tải"></van-tab>
				  <van-tab title="已完成"></van-tab>
				</van-tabs>
				
			</div>
		</div>
		<div class="layui-container" v-else>
			<div class="ucenter">
				<div class="uc-breadcrumb" >
					<el-link type="info" @click="back">
						<span class="iconfont icon-l-left"></span><span>返回</span>
					</el-link>
				</div>
				<UserPanel></UserPanel>
				<div class="ucenter-ht"></div>
				<div class="ucenter-content">
					<div class="ucenter-filter">
						<el-form ref="form" :model="form" label-width="80px">
							<el-row :gutter="20">
								<el-col :span="5">
									<el-form-item label="订单编号: ">
										<el-input v-model="form.did" placeholder="订单编号"></el-input>
									</el-form-item>
								</el-col>	
								<el-col :span="5">
									<el-form-item label="商品名称: ">
										<el-input v-model="form.name" placeholder="商品名称"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="5">
									<el-form-item label="订单状态:">
										<el-select v-model="form.status" placeholder="请选择">
											<el-option label="已收货" value="1"></el-option>
											<el-option label="已取消" value="2"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="9">
									<el-form-item label="下单时间: ">
										<el-date-picker
										v-model="form.daterange"
										type="daterange"
										range-separator="-"
										start-placeholder="开始日期"
										end-placeholder="结束日期">
										</el-date-picker>
									</el-form-item>
								</el-col>
							</el-row>	
						</el-form>
					</div>
					<div class="ucenter-cell">
						<div class="ucenter-content-hd"><span class="tt">购物记录</span></div>
						<el-table :data="tableData" border style="width: 100%">
							<el-table-column prop="id" label="序号" width="80" align="center">
							</el-table-column>
							<el-table-column prop="did" label="订单编号" width="120" align="center">
							</el-table-column>
							<el-table-column prop="date" label="下单时间" width="260" align="center">
							</el-table-column>
							<el-table-column prop="goodsinfo" label="商品" align="center">
								<template slot-scope="scope">
									<div class="goodsinfo-box">
										<div>
											{{scope.row.title}}
										</div>
										<div>
											{{scope.row.goodsinfo}}
										</div>
									</div>
								</template>
							</el-table-column>
							<el-table-column prop="price" label="订单金额" width="140" align="center">
							</el-table-column>
							<el-table-column prop="status" label="订单状态" width="140" align="center">
							</el-table-column>
						</el-table>
						<div class="ui-page">
							<el-pagination background layout="prev, pager, next" :total="1000">
							</el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	</div>
</template>
<script>
	import UserPanel from './components/UserPanel'

	export default {
		components: {
			UserPanel
		},
		data() {
			return {
				activeName: 0,
				form: {
					id:'',
					name: '',
					status:'',
					daterange:''
				},
				tableData: [{
					id: '1',
					did: '1000301',
					pic:require('@/assets/images/hot-picture.jpg'),
					date: '2024年05月16日 16:23:12',
					goodsinfo: '（颜色/黑色  尺码/L 数量/1 ）',
					title: "男士长款户外单人防暴雨黑eva时尚雨披",
					price: '67,230,000',
					status: '已收货'
				}, {
					id: '1',
					did: '1000301',
					pic:require('@/assets/images/hot-picture.jpg'),
					date: '2024年05月16日 16:23:12',
					goodsinfo: '（颜色/黑色  尺码/L 数量/1 ）',
					title: "男士长款户外单人防暴雨黑eva时尚雨披",
					price: '67,230,000',
					status: '已取消'
				}, {
					id: '1',
					did: '1000301',
					pic:require('@/assets/images/hot-picture.jpg'),
					date: '2024年05月16日 16:23:12',
					goodsinfo: '（颜色/黑色  尺码/L 数量/1 ）',
					title: "男士长款户外单人防暴雨黑eva时尚雨披",
					price: '67,230,000',
					status: '已收货'
				}, {
					id: '1',
					did: '1000301',
					pic:require('@/assets/images/hot-picture.jpg'),
					date: '2024年05月16日 16:23:12',
					goodsinfo: '（颜色/黑色  尺码/L 数量/1 ）',
					title: "男士长款户外单人防暴雨黑eva时尚雨披",
					price: '67,230,000',
					status: '已取消'
				}, {
					id: '1',
					did: '1000301',
					pic:require('@/assets/images/hot-picture.jpg'),
					date: '2024年05月16日 16:23:12',
					goodsinfo: '（颜色/黑色  尺码/L 数量/1 ）',
					title: "男士长款户外单人防暴雨黑eva时尚雨披",
					price: '67,230,000',
					status: '已收货'
				}, {
					id: '1',
					did: '1000301',
					pic:require('@/assets/images/hot-picture.jpg'),
					date: '2024年05月16日 16:23:12',
					goodsinfo: '（颜色/黑色  尺码/L 数量/1 ）',
					title: "男士长款户外单人防暴雨黑eva时尚雨披",
					price: '67,230,000',
					status: '已取消'
				}, {
					id: '1',
					did: '1000301',
					pic:require('@/assets/images/hot-picture.jpg'),
					date: '2024年05月16日 16:23:12',
					goodsinfo: '（颜色/黑色  尺码/L 数量/1 ）',
					title: "男士长款户外单人防暴雨黑eva时尚雨披",
					price: '67,230,000',
					status: '已收货'
				}, {
					id: '1',
					did: '1000301',
					pic:require('@/assets/images/hot-picture.jpg'),
					date: '2024年05月16日 16:23:12',
					goodsinfo: '（颜色/黑色  尺码/L 数量/1 ）',
					title: "男士长款户外单人防暴雨黑eva时尚雨披",
					price: '67,230,000',
					status: '已取消'
				}, ]
			};
		},
		methods: {
			onSubmit() {
				console.log('submit!');
			}
		},
		mounted() {}
	}
</script>
<style scoped>
	.uc-breadcrumb {
		margin-bottom: 15px;
	}

	.ucenter-ht {
		height: 20px;
	}
	.page-m-tabs ::v-deep .van-tabs__wrap{
		background-color: #EDDEC9;
		margin:-15px -15px 0 -15px;
	}
	.page-m-tabs ::v-deep .van-tabs__nav{
		background-color: transparent;
	}
	.h-lists{
		padding: 15px 0;
	}
	.history-card{
		display: flex;
		align-items: center;
		background: #FFFFFF;
		padding: 10px;
		margin-bottom: 10px;
		box-shadow: 0px 1px 6px 0px rgba(152,152,152,0.19);
		.h-photo{
			margin-right: 10px;
			img{
				width: 80px;
				height: 80px;
			}
		}
		.h-title{
			margin-bottom: 5px;
		}
		.h-item{
			margin-bottom: 5px;
			font-size: 13px;
		}
		.h-item.flex{
			justify-content: space-between;
		}
	}
	
	
	
	
</style>